import request from '@/lib/api'

const _BASE = "/api";

//根据字典类型获取字典项
export function getDict(type) {
  return request({
    url: `${_BASE}/dictionary/items/${type}`,
    method: 'get',
  })
}



export function getDicts(data) {
  return request({
    url: `${_BASE}/dictionary/item`,
    method: 'get',
    params: data
  })
}